import { ChannelFeedResponse as _ChannelFeedResponse, defaultState } from './fetchChannelFeed'
export type ChannelFeedResponse = _ChannelFeedResponse
export { default } from './fetchChannelFeed'
export { defaultState }
